import React from "react";
import Editor from "@bit/ses-education.ses-courses-shared-components.tinymce-editor";

import "./plugins/add-icon";
import "./plugins/alignment";
import "./plugins/run-and-code-blocks";

import { addIconsButtons, addIconsFormats } from "./plugins/add-icon";
import { addButtons, addFormats } from "./plugins/run-and-code-blocks";
import {
  addIconsButtons as IconButtons2,
  addIconsFormats as IconFormats2,
} from "./plugins/alignment";
import Service from "../../services/programService";
import "./program-editor.scss";
import { Button, ButtonGroup } from "@material-ui/core";
import Display from "./Display";

// const { REACT_APP_DOCUMENT_BASE_URL } = process.env;

// import ProgramService from "../../services/programService";

// console.debug( " addIconsFormats, addIconsButtons:", addIconsFormats, addIconsButtons);
// console.debug( " addIconsFormats, addIconsButtons:", IconFormats2, IconButtons2);

// const file_picker_callback  = (cb, value, meta) => {

//     let input = document.createElement('input');
//     input.setAttribute('type', 'file');
//     input.setAttribute('accept', 'image/*');

//     input.onchange = function(){

//         // get the file from files
//         let file = this.files[0];

//         let reader = new FileReader();

//         reader.onload = async function () {

//             // prepare form data with needed name
//             const data = new FormData();
//             data.append("image", file );

//             // send form data
//             const result = await Service.uploadImage(data);
//             // const result = await Service.uploadImageToProgram(data, program_id );
//             if (result && result.url) {
//                 const { url } = result;
//                 cb(url, { title: file.name });
//                 console.log("Url:", url)
//             }  else {
//                 // TODO: show a message
//                 console.log('IMAGE UPLOAD FAILED, result: ', result);

//             }
//         };
//         reader.readAsDataURL(file);
//     };
//     input.click();
// }

class ProgramEditor extends React.Component {
  state = {
    editing: false,
    editorContainerClass: "runandcode", // playandexplore|runandcode - play: 560px, code: 100%
  };

  // init = {
  //     formats: {...addIconsFormats, ...IconFormats2},
  //     plugins: ["add-icon", "alignment"],
  //     toolbar: `undo redo | formatselect | bold italic backcolor | \
  //     image \ ${IconButtons2} \ |
  //     bullist numlist outdent indent | removeformat | help \n ${addIconsButtons}`,
  //     // alignleft aligncenter alignright alignjustify | \
  //     content_css: "/css/custom-content.css",

  //     // add filepicker
  //     file_picker_callback
  // }

  componentDidMount() {
    const { program_type } = this.props;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.containerWidth !== this.props.containerWidth) {
      this.forceUpdate();
    }
  }

  /**
   * Prepares init object for the editor.
   * Needs program id for the file picker script that uses
   * ajax call to program-id-based URL.
   * @param {*} program_id
   */
  prepateEditorInit(program_id) {
    const { program_type, containerWidth } = this.props;

    const initByType = {
      playandexplore: {
        formats: { ...addIconsFormats, ...IconFormats2, ...addFormats },
        plugins: ["add-icon", "alignment"],
        width: 1502,
        height: 838,
        contextmenu: ["run-and-code-blocks"],
      },
      runandcode: {
        formats: { ...addIconsFormats, ...IconFormats2, ...addFormats },
        plugins: ["add-icon", "alignment", "run-and-code-blocks"],
        width: containerWidth, // 550,
        height: 847,
        contextmenu: ["run-and-code-blocks"],
      },
    };

    return {
      // formats: { ...addIconsFormats, ...IconFormats2, ...addFormats },
      // plugins: ["add-icon", "alignment", "run-and-code-blocks"],

      // override and use several toolbars via toolbar(n) option
      toolbar1: `undo redo | formatselect | bold italic backcolor | \
            image \ ${IconButtons2} \ |
            bullist numlist outdent indent | removeformat | help `,
      toolbar2: `${addIconsButtons} | ${addButtons}`,

      // alignleft aligncenter alignright alignjustify | \
      content_css: "/css/custom-content.css",

      // add filepicker
      file_picker_callback: (cb, value, meta) => {
        let input = document.createElement("input");
        input.setAttribute("type", "file");
        input.setAttribute("accept", "image/*");

        input.onchange = function () {
          // get the file from files
          let file = this.files[0];

          let reader = new FileReader();

          reader.onload = async function () {
            // prepare form data with needed name
            const data = new FormData();
            data.append("image", file);

            // send form data
            // const result = await Service.uploadImage(data);
            const result = await Service.uploadImageToProgram(data, program_id);
            if (result && result.url) {
              const { url } = result;
              cb(url, { title: file.name });
              return;
            }
            // else {

            // TODO: show a message
            console.log("IMAGE UPLOAD FAILED, result: ", result);

            // }
          };
          reader.readAsDataURL(file);
        };
        input.click();
      },

      // run an additional script after init
      init_instance_callback: (editor) => {
        // add scrolling listener
        editor.on("ScrollContent", (e) => {
          // console.log("ScrollContent", e.target.documentElement.scrollTop);
          const doc = e.target?.documentElement || {};
          const { scrollTop } = doc;
          const body = doc.getElementsByTagName("body")[0];
          // console.debug("body:", body);
          const isScrolled = body?.classList?.contains("scrolled");
          if (scrollTop > 0 && !isScrolled) {
            console.debug("marking as scrolled");
            body && body.classList.add("scrolled");
          } else if (scrollTop === 0 && isScrolled) {
            console.debug("marking as not scrolled");
            body && body.classList.remove("scrolled");
          }
        });
      },

      // mixin settings relevant to each program type
      ...(initByType[program_type] || {}),
    };
  }

  onSave = async (html) => {
    const { onSave } = this.props;
    if (!onSave || typeof onSave !== "function") {
      console.debug("onSave callback not set");
      return; // quit
    }
    // TODO: block the editor while saving and unblock after getting the result
    const saved = await onSave(html);
    if (saved) {
      alert("HTML saved");
    }
  };

  render() {
    const { editing, editorContainerClass, containerWidth = 550 } = this.state;
    const {
      html = "",
      title,
      slug,
      program_id,
      program_type,
      category_slug,
      lang = "en",
    } = this.props;

    console.debug("props:", this.props);

    const editorInit = this.prepateEditorInit(program_id);

    if (editing) {
      return (
        <>
          <div
            className={`editor-container ${editorContainerClass}`}
            style={{ width: `calc(${containerWidth}px + 4em)` }}
          >
            <Editor
              value={html}
              onSave={this.onSave}
              onCancel={() => this.setState({ editing: false })}
              init={{
                ...editorInit,
                width: containerWidth,
                body_class: `type-${program_type} category-${category_slug}`,
              }}
              // init = {this.init}
            />
          </div>
        </>
      );
    }

    return (
      <>
        <h2>{title}</h2>

        <div className="buttons">
          <Button
            variant="contained"
            size="medium"
            color="primary"
            onClick={() => this.setState({ editing: true })}
          >
            Edit content
          </Button>
          <ButtonGroup className="variant-select">
            <Button onClick={() => this.setState({ containerWidth: 550 })}>
              Narrow window
            </Button>
            <Button onClick={() => this.setState({ containerWidth: 1502 })}>
              Wide window
            </Button>
          </ButtonGroup>

          {/* <Button
            variant="contained"
            size="medium"
            // color="secondary"
            className="width-switch"
            onClick={() =>
              this.setState({ editorContainerClass: "playandexplore" })
            }
          >
            Width: Play & explore
          </Button>
          <Button
            variant="contained"
            size="medium"
            // color="secondary"
            className="width-switch"
            onClick={() =>
              this.setState({ editorContainerClass: "runandcode" })
            }
          >
            Width: Run & code
          </Button> */}
        </div>
        <div
          className={`editor-container ${editorContainerClass}`}
          style={{ width: `${containerWidth}px` }}
        >
          <Display {...{ html, slug, program_type, lang, program_id }} />
          {/* <div dangerouslySetInnerHTML={{__html: html}}></div> */}
        </div>
      </>
    );
  }
}

export default ProgramEditor;
